<template>
<div>
  <Interventi />
</div>
</template>
<script>
import Interventi from "@/components/MANUTENZIONE/Interventi.vue";
export default {
  name: "ManutenzioneInterventi",
  components: {Interventi},
  props: {},
  data() {
    return {
        // Variabili d'appoggio
        // Modal
        // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {

  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>